import { createStore, createEffect, createEvent } from 'effector';
import { $notificationStore } from '../notificationStore';
import { FileUtils, ApiUtils } from '@shared/utils';
import { StatementsApi } from '@shared/api/rest';
import type { DownloadStatementRequest } from '@shared/api/rest/statements';
import { type IQueryParams, RequestStrategyEnum } from '@shared/api/models';

const downloadStatementEffect = createEffect((params: IQueryParams<DownloadStatementRequest>) =>
  StatementsApi.download(params.request, params?.signal),
);
const clearEvent = createEvent();

const $loadingStore = createStore<boolean>(false)
  .on(downloadStatementEffect.pending, (_, data) => data)
  .on(downloadStatementEffect.fail, (_, data) => false)
  .on(downloadStatementEffect.done, (_, data) => false)
  .reset(clearEvent);

const $loadingIds = createStore<string[]>([])
  .on(downloadStatementEffect, (state, { request }) => (state.includes(request.id) ? state : [...state, request.id]))
  .on(downloadStatementEffect.done, (state, { params }) => state.filter((id) => id !== params.request.id))
  .on(downloadStatementEffect.fail, (state, { params }) => state.filter((id) => id !== params.request.id))
  .reset(clearEvent);

downloadStatementEffect.done.watch((result) => FileUtils.downloadFile(result.result));
downloadStatementEffect.fail.watch((x) => $notificationStore.events.setError(x.error.message));

export const $downloadStatementStore = {
  events: {
    downloadStatement: ApiUtils.wrapperApi(downloadStatementEffect, RequestStrategyEnum.Debounce),
    clear: clearEvent,
  },
  store: {
    loading: $loadingStore,
    loadingIds: $loadingIds,
  },
};
